import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AccessDenied = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div
      style={{
        minHeight: "calc(100vh - 120px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px",
      }}
    >
      <div
        style={{
          maxWidth: "520px",
          width: "100%",
          background: "#fff",
          borderRadius: "16px",
          padding: "32px",
          boxShadow: "0 12px 32px rgba(15, 23, 42, 0.08)",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: "40px", marginBottom: "12px" }}>403</div>
        <h1 style={{ margin: 0, fontSize: "28px", color: "#111827" }}>
          Access denied
        </h1>
        <p style={{ margin: "12px 0 24px", color: "#6b7280", lineHeight: 1.6 }}>
          You do not have permission to view this page.
          {location.state?.from?.pathname
            ? ` Requested path: ${location.state.from.pathname}`
            : ""}
        </p>
        <button
          type="button"
          onClick={() => navigate("/dashboard")}
          style={{
            border: "none",
            background: "#f77600",
            color: "#fff",
            padding: "12px 18px",
            borderRadius: "10px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Go to dashboard
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;